import { render } from "./Skeletons.vue?vue&type=template&id=1e28e954"
import script from "./Skeletons.vue?vue&type=script&lang=js"
export * from "./Skeletons.vue?vue&type=script&lang=js"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__